import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { Opening } from 'app/components/pages/Extranet/ExtranetInventory/Legacy/type';
import type { IBulkEditPayload } from 'app/typings/bulkEdit';
import { apiMutation } from 'app/utils/request/api';

import { getInventoryPath } from './hotels/extranet/useInventory';

const path = '/extranet/:hotelId/bulk-openings' as const;

export function useBulkEditSave(hotelId: number, start?: Date | string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: IBulkEditPayload) =>
      apiMutation(
        'POST',
        {
          path,
          params: { hotelId: hotelId.toString() },
        },
        payload
      ) as Promise<Opening[]>,
    onSuccess: (_, bulkEditPayload) => {
      if (!bulkEditPayload?.dryRun) {
        queryClient.invalidateQueries([
          getInventoryPath,
          { hotelId, startDate: start },
        ]);
      }
    },
    onError: () => {
      message.error('Error saving BulkEdit');
    },
  });
}
